export default {
    indexDepartaments:    { method: 'get',    url: 'departaments' },
    createDepartament:    { method: 'post',   url: 'departaments'},
    updateDepartament:    { method: 'put',    url: 'departaments/{id}'},
    deleteDepartament:    { method: 'delete', url: 'departaments/{id}'}
}